<script setup lang="ts">
// @ts-nocheck
import { onMounted, ref } from "vue";
import { LCIAResult } from "@/types/Views/MaterialDatabase/Material";

import { useEnum } from "@/stores/project/project.enum.ts";

import StagesTableTable from "./StagesTableTable";
import { storeToRefs } from "pinia";

import type { IndicatorTypeName } from "@/stores/project/types/enum.ts";

const enumStore = useEnum();
const { lifeCycleStages, indicatorUnits } = storeToRefs(enumStore);

const props = defineProps<{
  lciaResults: Array<LCIAResult>;
  indicatorTypeNames: { [key: number]: string } | undefined;
}>();

const cleanedLciaResults = ref<Array<LCIAResult>>([]);

onMounted(async () => {
  // Get all indicator types as unique values
  const indicatorTypes = new Set<number>();
  props.lciaResults.forEach((result) => {
    result.indicators.forEach((indicator) => {
      indicatorTypes.add(indicator.type);
    });
  });

  // Create default empty indicators based on type
  const defaultIndicators: LCIAResult["indicators"] = Array.from(indicatorTypes).map((type) => {
    const originalIdentifier = props.indicatorTypeNames?.[type] ?? "";
    const unit = indicatorUnits.value?.[originalIdentifier as unknown as IndicatorTypeName] ?? "";
    return {
      source: 0,
      type,
      value: null,
      unit,
      originalIdentifier,
    };
  });

  // Fill Lcia results indicators based on indicator type
  cleanedLciaResults.value = props.lciaResults.map((result) => {
    const indicators: LCIAResult["indicators"] = result?.indicators.map((indicator) => {
      const type = indicator.type;
      const originalIdentifier = props.indicatorTypeNames?.[type] ?? "";
      const unit = indicatorUnits.value?.[originalIdentifier as unknown as IndicatorTypeName] ?? "";

      return {
        ...indicator,
        originalIdentifier,
        unit,
      };
    });

    // Combine default indicators with existing indicators to ensure all indicators are present
    const combinedIndicators = defaultIndicators.map((defaultIndicator) => {
      const existingIndicator = indicators.find((indicator) => indicator.type === defaultIndicator.type);
      return existingIndicator ?? defaultIndicator;
    });

    return {
      ...result,
      indicators: combinedIndicators,
    };
  });
});
</script>

<template>
  <StagesTableTable
    v-if="lifeCycleStages"
    :lcia-results="cleanedLciaResults"
    :indicator-type-names="indicatorTypeNames"
    :stages="lifeCycleStages" />
</template>
